import { render, staticRenderFns } from "./PopupDataEditNotification.vue?vue&type=template&id=affe1476&scoped=true&"
import script from "./PopupDataEditNotification.vue?vue&type=script&lang=js&"
export * from "./PopupDataEditNotification.vue?vue&type=script&lang=js&"
import style0 from "./PopupDataEditNotification.vue?vue&type=style&index=0&id=affe1476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affe1476",
  null
  
)

export default component.exports